export const FETCH_FORGOT_PASSWORD_REQUEST = 'FETCH_FORGOT_PASSWORD_REQUEST'
export const FETCH_FORGOT_PASSWORD_SUCCESS = 'FETCH_FORGOT_PASSWORD_SUCCESS'
export const FETCH_FORGOT_PASSWORD_FALUIRE = 'FETCH_FORGOT_PASSWORD_FALUIRE'
export const CLEAR_FORGOT_PASSWORD_ERROR = 'CLEAR_FORGOT_PASSWORD_ERROR'
export const CLEAR_CLEAR_FORGOT_PASSWORD_INFO = 'CLEAR_CLEAR_FORGOT_PASSWORD_INFO'
